import React from 'react';
import {FlatList} from 'react-native';
import {responsiveWidth} from 'react-native-responsive-dimensions';

import {theme} from '../constants';
import {components} from '../components';
import {text} from '../text';
import {useGetReviewsQuery} from '../store/slices/apiSlice';

const Reviews: React.FC = (): JSX.Element => {
  const {data, error, isLoading} = useGetReviewsQuery();

  const reviews = Array.isArray(data) ? data : [];

  const renderStatusBar = () => {
    return <components.StatusBar />;
  };

  const renderHeader = () => {
    return <components.Header goBack={true} title='Reviews' />;
  };

  const renderContent = () => {
    if (isLoading) {
      return <components.Loader />;
    }

    if (reviews.length === 0) {
      return (
        <components.KAScrollView
          contentContainerStyle={{
            flexGrow: 1,
            padding: 20,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <text.H3 style={{marginBottom: 12}}>No reviews yet</text.H3>
          <text.T16 style={{textAlign: 'center'}}>
            Reviews will appear here once customers share their feedback.
          </text.T16>
        </components.KAScrollView>
      );
    }

    return (
      <FlatList
        data={reviews}
        contentContainerStyle={{
          paddingLeft: 20,
          marginTop: 10,
          marginBottom: 20,
        }}
        showsHorizontalScrollIndicator={false}
        keyExtractor={(item) => item.id}
        pagingEnabled={true}
        snapToInterval={theme.sizes.width - 54}
        decelerationRate={0}
        renderItem={({item, index}) => {
          const last = index === reviews.length - 1;
          return (
            <components.ReviewItem
              item={item}
              last={last}
              containerStyle={{
                width: responsiveWidth(100) - 40,
                marginBottom: last ? 0 : 14,
              }}
            />
          );
        }}
      />
    );
  };

  const renderHomeIndicator = () => {
    return <components.HomeIndicator />;
  };

  return (
    <components.SmartView>
      {renderStatusBar()}
      {renderHeader()}
      {renderContent()}
      {renderHomeIndicator()}
    </components.SmartView>
  );
};

export default Reviews;
